module.exports = __webpack_public_path__ + "static/media/sitting.d36548a4.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/sitting.png
 ** module id = 294
 ** module chunks = 0
 **/